var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 431.8,
    height: 127.416,
    viewBox: "0 0 431.8 127.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.472,
    y1: 1.035,
    x2: 2.361,
    y2: 1.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.95,
    y1: 1.879,
    x2: 1.69,
    y2: 1.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.926,
    y1: 0.946,
    x2: 1.835,
    y2: 0.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.856,
    y1: 2.093,
    x2: 1.897,
    y2: 2.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#04ea75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-1244 -1118.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M415.8,127.416H16A16.007,16.007,0,0,1,0,111.489V15.927A15.986,15.986,0,0,1,16,0H415.8a15.992,15.992,0,0,1,16,15.927v95.562A16.012,16.012,0,0,1,415.8,127.416Z",
    transform: "translate(1244 1118.127)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1750.362,291.9a9.694,9.694,0,0,1-7.237-2.995,10.2,10.2,0,0,1-2.923-7.308,9.972,9.972,0,0,1,2.923-7.3,9.664,9.664,0,0,1,7.229-2.995,9.794,9.794,0,0,1,7.237,2.995,10.577,10.577,0,0,1,0,14.6A9.613,9.613,0,0,1,1750.362,291.9Zm-85.8,0a10.052,10.052,0,0,1-7.268-2.955,10.3,10.3,0,0,1,7.268-17.635,10.129,10.129,0,0,1,4.059.842,8.209,8.209,0,0,1,3.09,2.208l.191.23-2.153,2.113-.222-.262a6.119,6.119,0,0,0-5-2.153,6.906,6.906,0,0,0-4.981,2.034,7.722,7.722,0,0,0,0,10.581,7.282,7.282,0,0,0,10.1,0,5.5,5.5,0,0,0,1.462-3.312h-6.9v-2.971h9.866l.04.27a10.894,10.894,0,0,1,.143,1.493,8.944,8.944,0,0,1-2.463,6.593A9.611,9.611,0,0,1,1664.563,291.9Zm114.079-.421H1775.6l-9.318-14.91.079,2.685v12.217h-3.042v-19.74h3.471l.1.151,8.762,14.044-.079-2.677V271.729h3.074v19.748Zm-51.141,0h-3.082V274.7h-5.346v-2.971h13.766V274.7h-5.346v16.777Zm-10.938,0h-3.074V271.729h3.074Zm-17.277,0h-3.074V274.7h-5.346v-2.971h13.766V274.7h-5.346Zm-10.366-.032H1677.13V271.729h11.788V274.7h-8.706v5.418h7.856v2.939h-7.856v5.418h8.706Zm56.463-4.583a6.8,6.8,0,0,0,4.981,2.065,6.63,6.63,0,0,0,4.981-2.065,7.828,7.828,0,0,0,.008-10.517,6.815,6.815,0,0,0-4.981-2.065,6.6,6.6,0,0,0-4.973,2.065,7.838,7.838,0,0,0-.016,10.517Z",
    transform: "translate(-278.889 868.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M1732.92,698.045a13.552,13.552,0,1,0,13.592,13.552A13.339,13.339,0,0,0,1732.92,698.045Zm0,21.734c-4.107,0-7.642-3.4-7.642-8.214,0-4.885,3.543-8.214,7.642-8.214s7.642,3.328,7.642,8.214C1740.57,716.411,1737.027,719.779,1732.92,719.779Zm-29.654-21.734a13.552,13.552,0,1,0,13.592,13.552A13.339,13.339,0,0,0,1703.267,698.045Zm0,21.734c-4.107,0-7.642-3.4-7.642-8.214,0-4.885,3.543-8.214,7.642-8.214s7.642,3.328,7.642,8.214C1710.908,716.411,1707.373,719.779,1703.267,719.779Zm-35.286-17.6v5.735h13.766a12.089,12.089,0,0,1-3.114,7.221,14.046,14.046,0,0,1-10.621,4.21,15.293,15.293,0,0,1,0-30.583,14.7,14.7,0,0,1,10.366,4.107l4.067-4.067a20,20,0,0,0-14.4-5.807,21.029,21.029,0,1,0,0,42.054c6.268,0,10.97-2.049,14.688-5.91,3.789-3.789,4.989-9.135,4.989-13.449a17.734,17.734,0,0,0-.318-3.575h-19.43C1667.981,702.112,1667.981,702.184,1667.981,702.184Zm144.328,4.464c-1.136-3.042-4.568-8.635-11.606-8.635-6.974,0-12.773,5.489-12.773,13.552a13.245,13.245,0,0,0,13.448,13.552,13.451,13.451,0,0,0,11.288-6.013l-4.6-3.082a7.707,7.707,0,0,1-6.657,3.749,6.921,6.921,0,0,1-6.585-4.107l18.119-7.507C1812.944,708.165,1812.309,706.648,1812.309,706.648Zm-18.477,4.528a7.438,7.438,0,0,1,7.078-7.9,5.224,5.224,0,0,1,5.028,2.868Zm-14.719,13.131h5.95V684.493h-5.95Zm-9.771-23.251h-.215a9.385,9.385,0,0,0-7.149-3.042c-6.76,0-12.988,5.95-12.988,13.592a13.39,13.39,0,0,0,12.988,13.488,9.36,9.36,0,0,0,7.149-3.082h.215v1.946c0,5.171-2.764,7.96-7.221,7.96a7.513,7.513,0,0,1-6.832-4.814l-5.171,2.161a12.935,12.935,0,0,0,11.995,8c6.974,0,12.885-4.107,12.885-14.124V698.824h-5.624v2.232Zm-6.832,18.723c-4.107,0-7.539-3.432-7.539-8.174,0-4.782,3.432-8.245,7.539-8.245,4.067,0,7.221,3.5,7.221,8.245C1769.771,716.347,1766.585,719.779,1762.51,719.779Zm77.657-35.286H1825.94v39.813h5.95V709.23h8.285c6.585,0,13.059-4.774,13.059-12.352S1846.784,684.493,1840.167,684.493Zm.175,19.176h-8.46V690.006h8.46a6.833,6.833,0,1,1,0,13.663Zm36.739-5.7c-4.321,0-8.778,1.914-10.621,6.085l5.275,2.192a5.657,5.657,0,0,1,5.417-2.939c3.082,0,6.2,1.843,6.268,5.132v.421a13.327,13.327,0,0,0-6.2-1.525c-5.7,0-11.471,3.114-11.471,8.952,0,5.346,4.671,8.778,9.874,8.778a8.375,8.375,0,0,0,7.57-3.892h.214v3.082h5.735V709.007C1889.148,701.906,1883.873,697.974,1877.081,697.974Zm-.747,21.805c-1.946,0-4.671-.953-4.671-3.4,0-3.082,3.4-4.25,6.3-4.25a10.327,10.327,0,0,1,5.418,1.342A7.162,7.162,0,0,1,1876.334,719.779Zm33.737-20.955-6.832,17.269h-.214l-7.078-17.269h-6.4l10.621,24.141-6.053,13.417h6.2l16.34-37.557Zm-53.556,25.483h5.95V684.493h-5.95Z",
    transform: "translate(-271.892 489.382)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M401.554,299.614a6.452,6.452,0,0,0-1.454,4.5v70.436A6.142,6.142,0,0,0,401.585,379l.246.214L441.3,339.754v-.882L401.8,299.4Z",
    transform: "translate(875.682 842.51)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M931.463,657.747,918.3,644.584v-.921L931.463,630.5l.286.175,15.57,8.849c4.456,2.51,4.456,6.657,0,9.2l-15.57,8.849Z",
    transform: "translate(398.646 537.712)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M471.559,815.449,458.11,802,418.4,841.71c1.454,1.557,3.892,1.732,6.617.214l46.542-26.476",
    transform: "translate(858.836 379.835)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M471.559,313.983l-46.542-26.436c-2.725-1.557-5.171-1.342-6.617.214l39.71,39.671Z",
    transform: "translate(858.836 854.404)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M471.641,967.7l-46.224,26.262c-2.582,1.485-4.885,1.382-6.371.032l-.246.246.246.214c1.485,1.342,3.789,1.454,6.371-.032l46.542-26.436Z",
    transform: "translate(858.468 227.298)",
    fillRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M1099.4,806.138l-15.9,9.024.286.286,15.57-8.849c2.232-1.271,3.328-2.939,3.328-4.6C1102.549,803.525,1101.413,804.971,1099.4,806.138Z",
    transform: "translate(246.569 379.835)",
    fillRule: "evenodd",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M408.171,287.846l62.111,35.286c2.018,1.136,3.154,2.621,3.328,4.139,0-1.66-1.1-3.328-3.328-4.6l-62.111-35.286c-4.456-2.55-8.071-.421-8.071,4.671v.461C400.1,287.417,403.714,285.328,408.171,287.846Z",
    transform: "translate(875.682 854.564)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.86c7ea559cc06829cf45203de36e284e.svg";
export { ForwardRef as ReactComponent };